// @generated by protobuf-ts 2.9.1 with parameter generate_dependencies
// @generated from protobuf file "druid.proto" (package "proto", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { UnitReference } from "./common";
/**
 * @generated from protobuf message proto.DruidTalents
 */
export interface DruidTalents {
    /**
     * Balance
     *
     * @generated from protobuf field: int32 starlight_wrath = 1;
     */
    starlightWrath: number;
    /**
     * @generated from protobuf field: int32 genesis = 2;
     */
    genesis: number;
    /**
     * @generated from protobuf field: int32 moonglow = 3;
     */
    moonglow: number;
    /**
     * @generated from protobuf field: int32 natures_majesty = 4;
     */
    naturesMajesty: number;
    /**
     * @generated from protobuf field: int32 improved_moonfire = 5;
     */
    improvedMoonfire: number;
    /**
     * @generated from protobuf field: int32 brambles = 6;
     */
    brambles: number;
    /**
     * @generated from protobuf field: int32 natures_grace = 7;
     */
    naturesGrace: number;
    /**
     * @generated from protobuf field: bool natures_splendor = 8;
     */
    naturesSplendor: boolean;
    /**
     * @generated from protobuf field: int32 natures_reach = 9;
     */
    naturesReach: number;
    /**
     * @generated from protobuf field: int32 vengeance = 10;
     */
    vengeance: number;
    /**
     * @generated from protobuf field: int32 celestial_focus = 11;
     */
    celestialFocus: number;
    /**
     * @generated from protobuf field: int32 lunar_guidance = 12;
     */
    lunarGuidance: number;
    /**
     * @generated from protobuf field: bool insect_swarm = 13;
     */
    insectSwarm: boolean;
    /**
     * @generated from protobuf field: int32 improved_insect_swarm = 14;
     */
    improvedInsectSwarm: number;
    /**
     * @generated from protobuf field: int32 dreamstate = 15;
     */
    dreamstate: number;
    /**
     * @generated from protobuf field: int32 moonfury = 16;
     */
    moonfury: number;
    /**
     * @generated from protobuf field: int32 balance_of_power = 17;
     */
    balanceOfPower: number;
    /**
     * @generated from protobuf field: bool moonkin_form = 18;
     */
    moonkinForm: boolean;
    /**
     * @generated from protobuf field: int32 improved_moonkin_form = 19;
     */
    improvedMoonkinForm: number;
    /**
     * @generated from protobuf field: int32 improved_faerie_fire = 20;
     */
    improvedFaerieFire: number;
    /**
     * @generated from protobuf field: int32 owlkin_frenzy = 21;
     */
    owlkinFrenzy: number;
    /**
     * @generated from protobuf field: int32 wrath_of_cenarius = 22;
     */
    wrathOfCenarius: number;
    /**
     * @generated from protobuf field: int32 eclipse = 23;
     */
    eclipse: number;
    /**
     * @generated from protobuf field: bool typhoon = 24;
     */
    typhoon: boolean;
    /**
     * @generated from protobuf field: bool force_of_nature = 25;
     */
    forceOfNature: boolean;
    /**
     * @generated from protobuf field: int32 gale_winds = 26;
     */
    galeWinds: number;
    /**
     * @generated from protobuf field: int32 earth_and_moon = 27;
     */
    earthAndMoon: number;
    /**
     * @generated from protobuf field: bool starfall = 28;
     */
    starfall: boolean;
    /**
     * Feral Combat
     *
     * @generated from protobuf field: int32 ferocity = 29;
     */
    ferocity: number;
    /**
     * @generated from protobuf field: int32 feral_aggression = 30;
     */
    feralAggression: number;
    /**
     * @generated from protobuf field: int32 feral_instinct = 31;
     */
    feralInstinct: number;
    /**
     * @generated from protobuf field: int32 savage_fury = 32;
     */
    savageFury: number;
    /**
     * @generated from protobuf field: int32 thick_hide = 33;
     */
    thickHide: number;
    /**
     * @generated from protobuf field: int32 feral_swiftness = 34;
     */
    feralSwiftness: number;
    /**
     * @generated from protobuf field: bool survival_instincts = 35;
     */
    survivalInstincts: boolean;
    /**
     * @generated from protobuf field: int32 sharpened_claws = 36;
     */
    sharpenedClaws: number;
    /**
     * @generated from protobuf field: int32 shredding_attacks = 37;
     */
    shreddingAttacks: number;
    /**
     * @generated from protobuf field: int32 predatory_strikes = 38;
     */
    predatoryStrikes: number;
    /**
     * @generated from protobuf field: int32 primal_fury = 39;
     */
    primalFury: number;
    /**
     * @generated from protobuf field: int32 primal_precision = 40;
     */
    primalPrecision: number;
    /**
     * @generated from protobuf field: int32 brutal_impact = 41;
     */
    brutalImpact: number;
    /**
     * @generated from protobuf field: bool feral_charge = 42;
     */
    feralCharge: boolean;
    /**
     * @generated from protobuf field: int32 nurturing_instinct = 43;
     */
    nurturingInstinct: number;
    /**
     * @generated from protobuf field: int32 natural_reaction = 44;
     */
    naturalReaction: number;
    /**
     * @generated from protobuf field: int32 heart_of_the_wild = 45;
     */
    heartOfTheWild: number;
    /**
     * @generated from protobuf field: int32 survival_of_the_fittest = 46;
     */
    survivalOfTheFittest: number;
    /**
     * @generated from protobuf field: bool leader_of_the_pack = 47;
     */
    leaderOfThePack: boolean;
    /**
     * @generated from protobuf field: int32 improved_leader_of_the_pack = 48;
     */
    improvedLeaderOfThePack: number;
    /**
     * @generated from protobuf field: int32 primal_tenacity = 49;
     */
    primalTenacity: number;
    /**
     * @generated from protobuf field: int32 protector_of_the_pack = 50;
     */
    protectorOfThePack: number;
    /**
     * @generated from protobuf field: int32 predatory_instincts = 51;
     */
    predatoryInstincts: number;
    /**
     * @generated from protobuf field: int32 infected_wounds = 52;
     */
    infectedWounds: number;
    /**
     * @generated from protobuf field: int32 king_of_the_jungle = 53;
     */
    kingOfTheJungle: number;
    /**
     * @generated from protobuf field: bool mangle = 54;
     */
    mangle: boolean;
    /**
     * @generated from protobuf field: int32 improved_mangle = 55;
     */
    improvedMangle: number;
    /**
     * @generated from protobuf field: int32 rend_and_tear = 56;
     */
    rendAndTear: number;
    /**
     * @generated from protobuf field: bool primal_gore = 57;
     */
    primalGore: boolean;
    /**
     * @generated from protobuf field: bool berserk = 58;
     */
    berserk: boolean;
    /**
     * Restoration
     *
     * @generated from protobuf field: int32 improved_mark_of_the_wild = 59;
     */
    improvedMarkOfTheWild: number;
    /**
     * @generated from protobuf field: int32 natures_focus = 60;
     */
    naturesFocus: number;
    /**
     * @generated from protobuf field: int32 furor = 61;
     */
    furor: number;
    /**
     * @generated from protobuf field: int32 naturalist = 62;
     */
    naturalist: number;
    /**
     * @generated from protobuf field: int32 subtlety = 63;
     */
    subtlety: number;
    /**
     * @generated from protobuf field: int32 natural_shapeshifter = 64;
     */
    naturalShapeshifter: number;
    /**
     * @generated from protobuf field: int32 intensity = 65;
     */
    intensity: number;
    /**
     * @generated from protobuf field: bool omen_of_clarity = 66;
     */
    omenOfClarity: boolean;
    /**
     * @generated from protobuf field: int32 master_shapeshifter = 67;
     */
    masterShapeshifter: number;
    /**
     * @generated from protobuf field: int32 tranquil_spirit = 68;
     */
    tranquilSpirit: number;
    /**
     * @generated from protobuf field: int32 improved_rejuvenation = 69;
     */
    improvedRejuvenation: number;
    /**
     * @generated from protobuf field: bool natures_swiftness = 70;
     */
    naturesSwiftness: boolean;
    /**
     * @generated from protobuf field: int32 gift_of_nature = 71;
     */
    giftOfNature: number;
    /**
     * @generated from protobuf field: int32 improved_tranquility = 72;
     */
    improvedTranquility: number;
    /**
     * @generated from protobuf field: int32 empowered_touch = 73;
     */
    empoweredTouch: number;
    /**
     * @generated from protobuf field: int32 natures_bounty = 74;
     */
    naturesBounty: number;
    /**
     * @generated from protobuf field: int32 living_spirit = 75;
     */
    livingSpirit: number;
    /**
     * @generated from protobuf field: bool swiftmend = 76;
     */
    swiftmend: boolean;
    /**
     * @generated from protobuf field: int32 natural_perfection = 77;
     */
    naturalPerfection: number;
    /**
     * @generated from protobuf field: int32 empowered_rejuvenation = 78;
     */
    empoweredRejuvenation: number;
    /**
     * @generated from protobuf field: int32 living_seed = 79;
     */
    livingSeed: number;
    /**
     * @generated from protobuf field: int32 revitalize = 80;
     */
    revitalize: number;
    /**
     * @generated from protobuf field: bool tree_of_life = 81;
     */
    treeOfLife: boolean;
    /**
     * @generated from protobuf field: int32 improved_tree_of_life = 82;
     */
    improvedTreeOfLife: number;
    /**
     * @generated from protobuf field: int32 improved_barkskin = 83;
     */
    improvedBarkskin: number;
    /**
     * @generated from protobuf field: int32 gift_of_the_earthmother = 84;
     */
    giftOfTheEarthmother: number;
    /**
     * @generated from protobuf field: bool wild_growth = 85;
     */
    wildGrowth: boolean;
}
/**
 * @generated from protobuf message proto.BalanceDruid
 */
export interface BalanceDruid {
    /**
     * @generated from protobuf field: proto.BalanceDruid.Options options = 3;
     */
    options?: BalanceDruid_Options;
}
/**
 * @generated from protobuf message proto.BalanceDruid.Rotation
 */
export interface BalanceDruid_Rotation {
}
/**
 * @generated from protobuf message proto.BalanceDruid.Options
 */
export interface BalanceDruid_Options {
    /**
     * @generated from protobuf field: proto.UnitReference innervate_target = 1;
     */
    innervateTarget?: UnitReference;
    /**
     * @generated from protobuf field: float okf_uptime = 2;
     */
    okfUptime: number;
}
/**
 * @generated from protobuf message proto.FeralDruid
 */
export interface FeralDruid {
    /**
     * @generated from protobuf field: proto.FeralDruid.Rotation rotation = 1;
     */
    rotation?: FeralDruid_Rotation;
    /**
     * @generated from protobuf field: proto.FeralDruid.Options options = 3;
     */
    options?: FeralDruid_Options;
}
/**
 * @generated from protobuf message proto.FeralDruid.Rotation
 */
export interface FeralDruid_Rotation {
    /**
     * @generated from protobuf field: proto.FeralDruid.Rotation.BearweaveType bear_weave_type = 1;
     */
    bearWeaveType: FeralDruid_Rotation_BearweaveType;
    /**
     * @generated from protobuf field: bool maintain_faerie_fire = 2;
     */
    maintainFaerieFire: boolean;
    /**
     * @generated from protobuf field: int32 min_combos_for_rip = 3;
     */
    minCombosForRip: number;
    /**
     * @generated from protobuf field: bool use_rake = 4;
     */
    useRake: boolean;
    /**
     * @generated from protobuf field: bool use_bite = 5;
     */
    useBite: boolean;
    /**
     * @generated from protobuf field: bool mangle_spam = 6;
     */
    mangleSpam: boolean;
    /**
     * @generated from protobuf field: float bite_time = 7;
     */
    biteTime: number;
    /**
     * @generated from protobuf field: int32 min_combos_for_bite = 8;
     */
    minCombosForBite: number;
    /**
     * @generated from protobuf field: int32 berserk_bite_thresh = 9;
     */
    berserkBiteThresh: number;
    /**
     * @generated from protobuf field: int32 berserk_ff_thresh = 18;
     */
    berserkFfThresh: number;
    /**
     * @generated from protobuf field: int32 rip_leeway = 19;
     */
    ripLeeway: number;
    /**
     * @generated from protobuf field: bool powerbear = 10;
     */
    powerbear: boolean;
    /**
     * @generated from protobuf field: float min_roar_offset = 11;
     */
    minRoarOffset: number;
    /**
     * @generated from protobuf field: proto.FeralDruid.Rotation.BiteModeType bite_mode_type = 12;
     */
    biteModeType: FeralDruid_Rotation_BiteModeType;
    /**
     * @generated from protobuf field: float hot_uptime = 13;
     */
    hotUptime: number;
    /**
     * @generated from protobuf field: bool snek_weave = 14;
     */
    snekWeave: boolean;
    /**
     * @generated from protobuf field: bool flower_weave = 15;
     */
    flowerWeave: boolean;
    /**
     * @generated from protobuf field: int32 raid_targets = 16;
     */
    raidTargets: number;
    /**
     * @generated from protobuf field: bool manual_params = 17;
     */
    manualParams: boolean;
    /**
     * @generated from protobuf field: float max_ff_delay = 20;
     */
    maxFfDelay: number;
    /**
     * @generated from protobuf field: proto.FeralDruid.Rotation.AplType rotation_type = 21;
     */
    rotationType: FeralDruid_Rotation_AplType;
    /**
     * @generated from protobuf field: bool pre_pop_berserk = 22;
     */
    prePopBerserk: boolean;
    /**
     * @generated from protobuf field: bool pre_pop_ooc = 23;
     */
    prePopOoc: boolean;
}
/**
 * @generated from protobuf enum proto.FeralDruid.Rotation.AplType
 */
export enum FeralDruid_Rotation_AplType {
    /**
     * @generated from protobuf enum value: SingleTarget = 0;
     */
    SingleTarget = 0,
    /**
     * @generated from protobuf enum value: Aoe = 1;
     */
    Aoe = 1
}
/**
 * @generated from protobuf enum proto.FeralDruid.Rotation.BearweaveType
 */
export enum FeralDruid_Rotation_BearweaveType {
    /**
     * @generated from protobuf enum value: None = 0;
     */
    None = 0,
    /**
     * @generated from protobuf enum value: Mangle = 1;
     */
    Mangle = 1,
    /**
     * @generated from protobuf enum value: Lacerate = 2;
     */
    Lacerate = 2
}
/**
 * @generated from protobuf enum proto.FeralDruid.Rotation.BiteModeType
 */
export enum FeralDruid_Rotation_BiteModeType {
    /**
     * @generated from protobuf enum value: Emperical = 0;
     */
    Emperical = 0,
    /**
     * @generated from protobuf enum value: Analytical = 1;
     */
    Analytical = 1
}
/**
 * @generated from protobuf message proto.FeralDruid.Options
 */
export interface FeralDruid_Options {
    /**
     * @generated from protobuf field: proto.UnitReference innervate_target = 1;
     */
    innervateTarget?: UnitReference;
    /**
     * @generated from protobuf field: int32 latency_ms = 2;
     */
    latencyMs: number;
    /**
     * @generated from protobuf field: bool assume_bleed_active = 4;
     */
    assumeBleedActive: boolean;
}
/**
 * @generated from protobuf message proto.FeralTankDruid
 */
export interface FeralTankDruid {
    /**
     * @generated from protobuf field: proto.FeralTankDruid.Options options = 3;
     */
    options?: FeralTankDruid_Options;
}
/**
 * @generated from protobuf message proto.FeralTankDruid.Rotation
 */
export interface FeralTankDruid_Rotation {
    /**
     * Minimum rage to queue HS or Cleave.
     *
     * @generated from protobuf field: int32 maul_rage_threshold = 1;
     */
    maulRageThreshold: number;
    /**
     * @generated from protobuf field: bool maintain_demoralizing_roar = 2;
     */
    maintainDemoralizingRoar: boolean;
    /**
     * @generated from protobuf field: double lacerate_time = 3;
     */
    lacerateTime: number;
}
/**
 * @generated from protobuf message proto.FeralTankDruid.Options
 */
export interface FeralTankDruid_Options {
    /**
     * @generated from protobuf field: proto.UnitReference innervate_target = 1;
     */
    innervateTarget?: UnitReference;
    /**
     * @generated from protobuf field: double starting_rage = 2;
     */
    startingRage: number;
}
/**
 * @generated from protobuf message proto.RestorationDruid
 */
export interface RestorationDruid {
    /**
     * @generated from protobuf field: proto.RestorationDruid.Options options = 3;
     */
    options?: RestorationDruid_Options;
}
/**
 * @generated from protobuf message proto.RestorationDruid.Rotation
 */
export interface RestorationDruid_Rotation {
}
/**
 * @generated from protobuf message proto.RestorationDruid.Options
 */
export interface RestorationDruid_Options {
    /**
     * @generated from protobuf field: proto.UnitReference innervate_target = 1;
     */
    innervateTarget?: UnitReference;
}
/**
 * @generated from protobuf enum proto.DruidMajorGlyph
 */
export enum DruidMajorGlyph {
    /**
     * @generated from protobuf enum value: DruidMajorGlyphNone = 0;
     */
    DruidMajorGlyphNone = 0,
    /**
     * @generated from protobuf enum value: GlyphOfBarkskin = 45623;
     */
    GlyphOfBarkskin = 45623,
    /**
     * @generated from protobuf enum value: GlyphOfBerserk = 45601;
     */
    GlyphOfBerserk = 45601,
    /**
     * @generated from protobuf enum value: GlyphOfClaw = 48720;
     */
    GlyphOfClaw = 48720,
    /**
     * @generated from protobuf enum value: GlyphOfEntanglingRoots = 40924;
     */
    GlyphOfEntanglingRoots = 40924,
    /**
     * @generated from protobuf enum value: GlyphOfFocus = 44928;
     */
    GlyphOfFocus = 44928,
    /**
     * @generated from protobuf enum value: GlyphOfFrenziedRegeneration = 40896;
     */
    GlyphOfFrenziedRegeneration = 40896,
    /**
     * @generated from protobuf enum value: GlyphOfGrowling = 40899;
     */
    GlyphOfGrowling = 40899,
    /**
     * @generated from protobuf enum value: GlyphOfHealingTouch = 40914;
     */
    GlyphOfHealingTouch = 40914,
    /**
     * @generated from protobuf enum value: GlyphOfHurricane = 40920;
     */
    GlyphOfHurricane = 40920,
    /**
     * @generated from protobuf enum value: GlyphOfInnervate = 40908;
     */
    GlyphOfInnervate = 40908,
    /**
     * @generated from protobuf enum value: GlyphOfInsectSwarm = 40919;
     */
    GlyphOfInsectSwarm = 40919,
    /**
     * @generated from protobuf enum value: GlyphOfLifebloom = 40915;
     */
    GlyphOfLifebloom = 40915,
    /**
     * @generated from protobuf enum value: GlyphOfMangle = 40900;
     */
    GlyphOfMangle = 40900,
    /**
     * @generated from protobuf enum value: GlyphOfMaul = 40897;
     */
    GlyphOfMaul = 40897,
    /**
     * @generated from protobuf enum value: GlyphOfMonsoon = 45622;
     */
    GlyphOfMonsoon = 45622,
    /**
     * @generated from protobuf enum value: GlyphOfMoonfire = 40923;
     */
    GlyphOfMoonfire = 40923,
    /**
     * @generated from protobuf enum value: GlyphOfNourish = 45603;
     */
    GlyphOfNourish = 45603,
    /**
     * @generated from protobuf enum value: GlyphOfOmenOfClarity = 206580;
     */
    GlyphOfOmenOfClarity = 206580,
    /**
     * @generated from protobuf enum value: GlyphOfRake = 40903;
     */
    GlyphOfRake = 40903,
    /**
     * @generated from protobuf enum value: GlyphOfRapidRejuvenation = 50125;
     */
    GlyphOfRapidRejuvenation = 50125,
    /**
     * @generated from protobuf enum value: GlyphOfRebirth = 40909;
     */
    GlyphOfRebirth = 40909,
    /**
     * @generated from protobuf enum value: GlyphOfRegrowth = 40912;
     */
    GlyphOfRegrowth = 40912,
    /**
     * @generated from protobuf enum value: GlyphOfRejuvenation = 40913;
     */
    GlyphOfRejuvenation = 40913,
    /**
     * @generated from protobuf enum value: GlyphOfRip = 40902;
     */
    GlyphOfRip = 40902,
    /**
     * @generated from protobuf enum value: GlyphOfSavageRoar = 45604;
     */
    GlyphOfSavageRoar = 45604,
    /**
     * @generated from protobuf enum value: GlyphOfShred = 40901;
     */
    GlyphOfShred = 40901,
    /**
     * @generated from protobuf enum value: GlyphOfStarfall = 40921;
     */
    GlyphOfStarfall = 40921,
    /**
     * @generated from protobuf enum value: GlyphOfStarfire = 40916;
     */
    GlyphOfStarfire = 40916,
    /**
     * @generated from protobuf enum value: GlyphOfSurvivalInstincts = 46372;
     */
    GlyphOfSurvivalInstincts = 46372,
    /**
     * @generated from protobuf enum value: GlyphOfSwiftmend = 40906;
     */
    GlyphOfSwiftmend = 40906,
    /**
     * @generated from protobuf enum value: GlyphOfWildGrowth = 45602;
     */
    GlyphOfWildGrowth = 45602,
    /**
     * @generated from protobuf enum value: GlyphOfWrath = 40922;
     */
    GlyphOfWrath = 40922
}
/**
 * @generated from protobuf enum proto.DruidMinorGlyph
 */
export enum DruidMinorGlyph {
    /**
     * @generated from protobuf enum value: DruidMinorGlyphNone = 0;
     */
    DruidMinorGlyphNone = 0,
    /**
     * @generated from protobuf enum value: GlyphOfAquaticForm = 43316;
     */
    GlyphOfAquaticForm = 43316,
    /**
     * @generated from protobuf enum value: GlyphOfChallengingRoar = 43334;
     */
    GlyphOfChallengingRoar = 43334,
    /**
     * @generated from protobuf enum value: GlyphOfDash = 43674;
     */
    GlyphOfDash = 43674,
    /**
     * @generated from protobuf enum value: GlyphOfTheWild = 43335;
     */
    GlyphOfTheWild = 43335,
    /**
     * @generated from protobuf enum value: GlyphOfThorns = 43332;
     */
    GlyphOfThorns = 43332,
    /**
     * @generated from protobuf enum value: GlyphOfTyphoon = 44922;
     */
    GlyphOfTyphoon = 44922,
    /**
     * @generated from protobuf enum value: GlyphOfUnburdenedRebirth = 43331;
     */
    GlyphOfUnburdenedRebirth = 43331
}
// @generated message type with reflection information, may provide speed optimized methods
class DruidTalents$Type extends MessageType<DruidTalents> {
    constructor() {
        super("proto.DruidTalents", [
            { no: 1, name: "starlight_wrath", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "genesis", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "moonglow", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "natures_majesty", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "improved_moonfire", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "brambles", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "natures_grace", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "natures_splendor", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "natures_reach", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "vengeance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "celestial_focus", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "lunar_guidance", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "insect_swarm", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "improved_insect_swarm", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "dreamstate", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "moonfury", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "balance_of_power", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "moonkin_form", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "improved_moonkin_form", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "improved_faerie_fire", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "owlkin_frenzy", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 22, name: "wrath_of_cenarius", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "eclipse", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 24, name: "typhoon", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "force_of_nature", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "gale_winds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "earth_and_moon", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "starfall", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "ferocity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 30, name: "feral_aggression", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 31, name: "feral_instinct", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "savage_fury", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 33, name: "thick_hide", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 34, name: "feral_swiftness", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 35, name: "survival_instincts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 36, name: "sharpened_claws", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 37, name: "shredding_attacks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 38, name: "predatory_strikes", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 39, name: "primal_fury", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 40, name: "primal_precision", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 41, name: "brutal_impact", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 42, name: "feral_charge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 43, name: "nurturing_instinct", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 44, name: "natural_reaction", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 45, name: "heart_of_the_wild", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 46, name: "survival_of_the_fittest", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 47, name: "leader_of_the_pack", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 48, name: "improved_leader_of_the_pack", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 49, name: "primal_tenacity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 50, name: "protector_of_the_pack", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 51, name: "predatory_instincts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 52, name: "infected_wounds", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 53, name: "king_of_the_jungle", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 54, name: "mangle", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 55, name: "improved_mangle", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 56, name: "rend_and_tear", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 57, name: "primal_gore", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 58, name: "berserk", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 59, name: "improved_mark_of_the_wild", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 60, name: "natures_focus", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 61, name: "furor", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 62, name: "naturalist", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 63, name: "subtlety", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 64, name: "natural_shapeshifter", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 65, name: "intensity", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 66, name: "omen_of_clarity", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 67, name: "master_shapeshifter", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 68, name: "tranquil_spirit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 69, name: "improved_rejuvenation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 70, name: "natures_swiftness", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 71, name: "gift_of_nature", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 72, name: "improved_tranquility", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 73, name: "empowered_touch", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 74, name: "natures_bounty", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 75, name: "living_spirit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 76, name: "swiftmend", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 77, name: "natural_perfection", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 78, name: "empowered_rejuvenation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 79, name: "living_seed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 80, name: "revitalize", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 81, name: "tree_of_life", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 82, name: "improved_tree_of_life", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 83, name: "improved_barkskin", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 84, name: "gift_of_the_earthmother", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 85, name: "wild_growth", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DruidTalents>): DruidTalents {
        const message = { starlightWrath: 0, genesis: 0, moonglow: 0, naturesMajesty: 0, improvedMoonfire: 0, brambles: 0, naturesGrace: 0, naturesSplendor: false, naturesReach: 0, vengeance: 0, celestialFocus: 0, lunarGuidance: 0, insectSwarm: false, improvedInsectSwarm: 0, dreamstate: 0, moonfury: 0, balanceOfPower: 0, moonkinForm: false, improvedMoonkinForm: 0, improvedFaerieFire: 0, owlkinFrenzy: 0, wrathOfCenarius: 0, eclipse: 0, typhoon: false, forceOfNature: false, galeWinds: 0, earthAndMoon: 0, starfall: false, ferocity: 0, feralAggression: 0, feralInstinct: 0, savageFury: 0, thickHide: 0, feralSwiftness: 0, survivalInstincts: false, sharpenedClaws: 0, shreddingAttacks: 0, predatoryStrikes: 0, primalFury: 0, primalPrecision: 0, brutalImpact: 0, feralCharge: false, nurturingInstinct: 0, naturalReaction: 0, heartOfTheWild: 0, survivalOfTheFittest: 0, leaderOfThePack: false, improvedLeaderOfThePack: 0, primalTenacity: 0, protectorOfThePack: 0, predatoryInstincts: 0, infectedWounds: 0, kingOfTheJungle: 0, mangle: false, improvedMangle: 0, rendAndTear: 0, primalGore: false, berserk: false, improvedMarkOfTheWild: 0, naturesFocus: 0, furor: 0, naturalist: 0, subtlety: 0, naturalShapeshifter: 0, intensity: 0, omenOfClarity: false, masterShapeshifter: 0, tranquilSpirit: 0, improvedRejuvenation: 0, naturesSwiftness: false, giftOfNature: 0, improvedTranquility: 0, empoweredTouch: 0, naturesBounty: 0, livingSpirit: 0, swiftmend: false, naturalPerfection: 0, empoweredRejuvenation: 0, livingSeed: 0, revitalize: 0, treeOfLife: false, improvedTreeOfLife: 0, improvedBarkskin: 0, giftOfTheEarthmother: 0, wildGrowth: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DruidTalents>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DruidTalents): DruidTalents {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 starlight_wrath */ 1:
                    message.starlightWrath = reader.int32();
                    break;
                case /* int32 genesis */ 2:
                    message.genesis = reader.int32();
                    break;
                case /* int32 moonglow */ 3:
                    message.moonglow = reader.int32();
                    break;
                case /* int32 natures_majesty */ 4:
                    message.naturesMajesty = reader.int32();
                    break;
                case /* int32 improved_moonfire */ 5:
                    message.improvedMoonfire = reader.int32();
                    break;
                case /* int32 brambles */ 6:
                    message.brambles = reader.int32();
                    break;
                case /* int32 natures_grace */ 7:
                    message.naturesGrace = reader.int32();
                    break;
                case /* bool natures_splendor */ 8:
                    message.naturesSplendor = reader.bool();
                    break;
                case /* int32 natures_reach */ 9:
                    message.naturesReach = reader.int32();
                    break;
                case /* int32 vengeance */ 10:
                    message.vengeance = reader.int32();
                    break;
                case /* int32 celestial_focus */ 11:
                    message.celestialFocus = reader.int32();
                    break;
                case /* int32 lunar_guidance */ 12:
                    message.lunarGuidance = reader.int32();
                    break;
                case /* bool insect_swarm */ 13:
                    message.insectSwarm = reader.bool();
                    break;
                case /* int32 improved_insect_swarm */ 14:
                    message.improvedInsectSwarm = reader.int32();
                    break;
                case /* int32 dreamstate */ 15:
                    message.dreamstate = reader.int32();
                    break;
                case /* int32 moonfury */ 16:
                    message.moonfury = reader.int32();
                    break;
                case /* int32 balance_of_power */ 17:
                    message.balanceOfPower = reader.int32();
                    break;
                case /* bool moonkin_form */ 18:
                    message.moonkinForm = reader.bool();
                    break;
                case /* int32 improved_moonkin_form */ 19:
                    message.improvedMoonkinForm = reader.int32();
                    break;
                case /* int32 improved_faerie_fire */ 20:
                    message.improvedFaerieFire = reader.int32();
                    break;
                case /* int32 owlkin_frenzy */ 21:
                    message.owlkinFrenzy = reader.int32();
                    break;
                case /* int32 wrath_of_cenarius */ 22:
                    message.wrathOfCenarius = reader.int32();
                    break;
                case /* int32 eclipse */ 23:
                    message.eclipse = reader.int32();
                    break;
                case /* bool typhoon */ 24:
                    message.typhoon = reader.bool();
                    break;
                case /* bool force_of_nature */ 25:
                    message.forceOfNature = reader.bool();
                    break;
                case /* int32 gale_winds */ 26:
                    message.galeWinds = reader.int32();
                    break;
                case /* int32 earth_and_moon */ 27:
                    message.earthAndMoon = reader.int32();
                    break;
                case /* bool starfall */ 28:
                    message.starfall = reader.bool();
                    break;
                case /* int32 ferocity */ 29:
                    message.ferocity = reader.int32();
                    break;
                case /* int32 feral_aggression */ 30:
                    message.feralAggression = reader.int32();
                    break;
                case /* int32 feral_instinct */ 31:
                    message.feralInstinct = reader.int32();
                    break;
                case /* int32 savage_fury */ 32:
                    message.savageFury = reader.int32();
                    break;
                case /* int32 thick_hide */ 33:
                    message.thickHide = reader.int32();
                    break;
                case /* int32 feral_swiftness */ 34:
                    message.feralSwiftness = reader.int32();
                    break;
                case /* bool survival_instincts */ 35:
                    message.survivalInstincts = reader.bool();
                    break;
                case /* int32 sharpened_claws */ 36:
                    message.sharpenedClaws = reader.int32();
                    break;
                case /* int32 shredding_attacks */ 37:
                    message.shreddingAttacks = reader.int32();
                    break;
                case /* int32 predatory_strikes */ 38:
                    message.predatoryStrikes = reader.int32();
                    break;
                case /* int32 primal_fury */ 39:
                    message.primalFury = reader.int32();
                    break;
                case /* int32 primal_precision */ 40:
                    message.primalPrecision = reader.int32();
                    break;
                case /* int32 brutal_impact */ 41:
                    message.brutalImpact = reader.int32();
                    break;
                case /* bool feral_charge */ 42:
                    message.feralCharge = reader.bool();
                    break;
                case /* int32 nurturing_instinct */ 43:
                    message.nurturingInstinct = reader.int32();
                    break;
                case /* int32 natural_reaction */ 44:
                    message.naturalReaction = reader.int32();
                    break;
                case /* int32 heart_of_the_wild */ 45:
                    message.heartOfTheWild = reader.int32();
                    break;
                case /* int32 survival_of_the_fittest */ 46:
                    message.survivalOfTheFittest = reader.int32();
                    break;
                case /* bool leader_of_the_pack */ 47:
                    message.leaderOfThePack = reader.bool();
                    break;
                case /* int32 improved_leader_of_the_pack */ 48:
                    message.improvedLeaderOfThePack = reader.int32();
                    break;
                case /* int32 primal_tenacity */ 49:
                    message.primalTenacity = reader.int32();
                    break;
                case /* int32 protector_of_the_pack */ 50:
                    message.protectorOfThePack = reader.int32();
                    break;
                case /* int32 predatory_instincts */ 51:
                    message.predatoryInstincts = reader.int32();
                    break;
                case /* int32 infected_wounds */ 52:
                    message.infectedWounds = reader.int32();
                    break;
                case /* int32 king_of_the_jungle */ 53:
                    message.kingOfTheJungle = reader.int32();
                    break;
                case /* bool mangle */ 54:
                    message.mangle = reader.bool();
                    break;
                case /* int32 improved_mangle */ 55:
                    message.improvedMangle = reader.int32();
                    break;
                case /* int32 rend_and_tear */ 56:
                    message.rendAndTear = reader.int32();
                    break;
                case /* bool primal_gore */ 57:
                    message.primalGore = reader.bool();
                    break;
                case /* bool berserk */ 58:
                    message.berserk = reader.bool();
                    break;
                case /* int32 improved_mark_of_the_wild */ 59:
                    message.improvedMarkOfTheWild = reader.int32();
                    break;
                case /* int32 natures_focus */ 60:
                    message.naturesFocus = reader.int32();
                    break;
                case /* int32 furor */ 61:
                    message.furor = reader.int32();
                    break;
                case /* int32 naturalist */ 62:
                    message.naturalist = reader.int32();
                    break;
                case /* int32 subtlety */ 63:
                    message.subtlety = reader.int32();
                    break;
                case /* int32 natural_shapeshifter */ 64:
                    message.naturalShapeshifter = reader.int32();
                    break;
                case /* int32 intensity */ 65:
                    message.intensity = reader.int32();
                    break;
                case /* bool omen_of_clarity */ 66:
                    message.omenOfClarity = reader.bool();
                    break;
                case /* int32 master_shapeshifter */ 67:
                    message.masterShapeshifter = reader.int32();
                    break;
                case /* int32 tranquil_spirit */ 68:
                    message.tranquilSpirit = reader.int32();
                    break;
                case /* int32 improved_rejuvenation */ 69:
                    message.improvedRejuvenation = reader.int32();
                    break;
                case /* bool natures_swiftness */ 70:
                    message.naturesSwiftness = reader.bool();
                    break;
                case /* int32 gift_of_nature */ 71:
                    message.giftOfNature = reader.int32();
                    break;
                case /* int32 improved_tranquility */ 72:
                    message.improvedTranquility = reader.int32();
                    break;
                case /* int32 empowered_touch */ 73:
                    message.empoweredTouch = reader.int32();
                    break;
                case /* int32 natures_bounty */ 74:
                    message.naturesBounty = reader.int32();
                    break;
                case /* int32 living_spirit */ 75:
                    message.livingSpirit = reader.int32();
                    break;
                case /* bool swiftmend */ 76:
                    message.swiftmend = reader.bool();
                    break;
                case /* int32 natural_perfection */ 77:
                    message.naturalPerfection = reader.int32();
                    break;
                case /* int32 empowered_rejuvenation */ 78:
                    message.empoweredRejuvenation = reader.int32();
                    break;
                case /* int32 living_seed */ 79:
                    message.livingSeed = reader.int32();
                    break;
                case /* int32 revitalize */ 80:
                    message.revitalize = reader.int32();
                    break;
                case /* bool tree_of_life */ 81:
                    message.treeOfLife = reader.bool();
                    break;
                case /* int32 improved_tree_of_life */ 82:
                    message.improvedTreeOfLife = reader.int32();
                    break;
                case /* int32 improved_barkskin */ 83:
                    message.improvedBarkskin = reader.int32();
                    break;
                case /* int32 gift_of_the_earthmother */ 84:
                    message.giftOfTheEarthmother = reader.int32();
                    break;
                case /* bool wild_growth */ 85:
                    message.wildGrowth = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DruidTalents, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 starlight_wrath = 1; */
        if (message.starlightWrath !== 0)
            writer.tag(1, WireType.Varint).int32(message.starlightWrath);
        /* int32 genesis = 2; */
        if (message.genesis !== 0)
            writer.tag(2, WireType.Varint).int32(message.genesis);
        /* int32 moonglow = 3; */
        if (message.moonglow !== 0)
            writer.tag(3, WireType.Varint).int32(message.moonglow);
        /* int32 natures_majesty = 4; */
        if (message.naturesMajesty !== 0)
            writer.tag(4, WireType.Varint).int32(message.naturesMajesty);
        /* int32 improved_moonfire = 5; */
        if (message.improvedMoonfire !== 0)
            writer.tag(5, WireType.Varint).int32(message.improvedMoonfire);
        /* int32 brambles = 6; */
        if (message.brambles !== 0)
            writer.tag(6, WireType.Varint).int32(message.brambles);
        /* int32 natures_grace = 7; */
        if (message.naturesGrace !== 0)
            writer.tag(7, WireType.Varint).int32(message.naturesGrace);
        /* bool natures_splendor = 8; */
        if (message.naturesSplendor !== false)
            writer.tag(8, WireType.Varint).bool(message.naturesSplendor);
        /* int32 natures_reach = 9; */
        if (message.naturesReach !== 0)
            writer.tag(9, WireType.Varint).int32(message.naturesReach);
        /* int32 vengeance = 10; */
        if (message.vengeance !== 0)
            writer.tag(10, WireType.Varint).int32(message.vengeance);
        /* int32 celestial_focus = 11; */
        if (message.celestialFocus !== 0)
            writer.tag(11, WireType.Varint).int32(message.celestialFocus);
        /* int32 lunar_guidance = 12; */
        if (message.lunarGuidance !== 0)
            writer.tag(12, WireType.Varint).int32(message.lunarGuidance);
        /* bool insect_swarm = 13; */
        if (message.insectSwarm !== false)
            writer.tag(13, WireType.Varint).bool(message.insectSwarm);
        /* int32 improved_insect_swarm = 14; */
        if (message.improvedInsectSwarm !== 0)
            writer.tag(14, WireType.Varint).int32(message.improvedInsectSwarm);
        /* int32 dreamstate = 15; */
        if (message.dreamstate !== 0)
            writer.tag(15, WireType.Varint).int32(message.dreamstate);
        /* int32 moonfury = 16; */
        if (message.moonfury !== 0)
            writer.tag(16, WireType.Varint).int32(message.moonfury);
        /* int32 balance_of_power = 17; */
        if (message.balanceOfPower !== 0)
            writer.tag(17, WireType.Varint).int32(message.balanceOfPower);
        /* bool moonkin_form = 18; */
        if (message.moonkinForm !== false)
            writer.tag(18, WireType.Varint).bool(message.moonkinForm);
        /* int32 improved_moonkin_form = 19; */
        if (message.improvedMoonkinForm !== 0)
            writer.tag(19, WireType.Varint).int32(message.improvedMoonkinForm);
        /* int32 improved_faerie_fire = 20; */
        if (message.improvedFaerieFire !== 0)
            writer.tag(20, WireType.Varint).int32(message.improvedFaerieFire);
        /* int32 owlkin_frenzy = 21; */
        if (message.owlkinFrenzy !== 0)
            writer.tag(21, WireType.Varint).int32(message.owlkinFrenzy);
        /* int32 wrath_of_cenarius = 22; */
        if (message.wrathOfCenarius !== 0)
            writer.tag(22, WireType.Varint).int32(message.wrathOfCenarius);
        /* int32 eclipse = 23; */
        if (message.eclipse !== 0)
            writer.tag(23, WireType.Varint).int32(message.eclipse);
        /* bool typhoon = 24; */
        if (message.typhoon !== false)
            writer.tag(24, WireType.Varint).bool(message.typhoon);
        /* bool force_of_nature = 25; */
        if (message.forceOfNature !== false)
            writer.tag(25, WireType.Varint).bool(message.forceOfNature);
        /* int32 gale_winds = 26; */
        if (message.galeWinds !== 0)
            writer.tag(26, WireType.Varint).int32(message.galeWinds);
        /* int32 earth_and_moon = 27; */
        if (message.earthAndMoon !== 0)
            writer.tag(27, WireType.Varint).int32(message.earthAndMoon);
        /* bool starfall = 28; */
        if (message.starfall !== false)
            writer.tag(28, WireType.Varint).bool(message.starfall);
        /* int32 ferocity = 29; */
        if (message.ferocity !== 0)
            writer.tag(29, WireType.Varint).int32(message.ferocity);
        /* int32 feral_aggression = 30; */
        if (message.feralAggression !== 0)
            writer.tag(30, WireType.Varint).int32(message.feralAggression);
        /* int32 feral_instinct = 31; */
        if (message.feralInstinct !== 0)
            writer.tag(31, WireType.Varint).int32(message.feralInstinct);
        /* int32 savage_fury = 32; */
        if (message.savageFury !== 0)
            writer.tag(32, WireType.Varint).int32(message.savageFury);
        /* int32 thick_hide = 33; */
        if (message.thickHide !== 0)
            writer.tag(33, WireType.Varint).int32(message.thickHide);
        /* int32 feral_swiftness = 34; */
        if (message.feralSwiftness !== 0)
            writer.tag(34, WireType.Varint).int32(message.feralSwiftness);
        /* bool survival_instincts = 35; */
        if (message.survivalInstincts !== false)
            writer.tag(35, WireType.Varint).bool(message.survivalInstincts);
        /* int32 sharpened_claws = 36; */
        if (message.sharpenedClaws !== 0)
            writer.tag(36, WireType.Varint).int32(message.sharpenedClaws);
        /* int32 shredding_attacks = 37; */
        if (message.shreddingAttacks !== 0)
            writer.tag(37, WireType.Varint).int32(message.shreddingAttacks);
        /* int32 predatory_strikes = 38; */
        if (message.predatoryStrikes !== 0)
            writer.tag(38, WireType.Varint).int32(message.predatoryStrikes);
        /* int32 primal_fury = 39; */
        if (message.primalFury !== 0)
            writer.tag(39, WireType.Varint).int32(message.primalFury);
        /* int32 primal_precision = 40; */
        if (message.primalPrecision !== 0)
            writer.tag(40, WireType.Varint).int32(message.primalPrecision);
        /* int32 brutal_impact = 41; */
        if (message.brutalImpact !== 0)
            writer.tag(41, WireType.Varint).int32(message.brutalImpact);
        /* bool feral_charge = 42; */
        if (message.feralCharge !== false)
            writer.tag(42, WireType.Varint).bool(message.feralCharge);
        /* int32 nurturing_instinct = 43; */
        if (message.nurturingInstinct !== 0)
            writer.tag(43, WireType.Varint).int32(message.nurturingInstinct);
        /* int32 natural_reaction = 44; */
        if (message.naturalReaction !== 0)
            writer.tag(44, WireType.Varint).int32(message.naturalReaction);
        /* int32 heart_of_the_wild = 45; */
        if (message.heartOfTheWild !== 0)
            writer.tag(45, WireType.Varint).int32(message.heartOfTheWild);
        /* int32 survival_of_the_fittest = 46; */
        if (message.survivalOfTheFittest !== 0)
            writer.tag(46, WireType.Varint).int32(message.survivalOfTheFittest);
        /* bool leader_of_the_pack = 47; */
        if (message.leaderOfThePack !== false)
            writer.tag(47, WireType.Varint).bool(message.leaderOfThePack);
        /* int32 improved_leader_of_the_pack = 48; */
        if (message.improvedLeaderOfThePack !== 0)
            writer.tag(48, WireType.Varint).int32(message.improvedLeaderOfThePack);
        /* int32 primal_tenacity = 49; */
        if (message.primalTenacity !== 0)
            writer.tag(49, WireType.Varint).int32(message.primalTenacity);
        /* int32 protector_of_the_pack = 50; */
        if (message.protectorOfThePack !== 0)
            writer.tag(50, WireType.Varint).int32(message.protectorOfThePack);
        /* int32 predatory_instincts = 51; */
        if (message.predatoryInstincts !== 0)
            writer.tag(51, WireType.Varint).int32(message.predatoryInstincts);
        /* int32 infected_wounds = 52; */
        if (message.infectedWounds !== 0)
            writer.tag(52, WireType.Varint).int32(message.infectedWounds);
        /* int32 king_of_the_jungle = 53; */
        if (message.kingOfTheJungle !== 0)
            writer.tag(53, WireType.Varint).int32(message.kingOfTheJungle);
        /* bool mangle = 54; */
        if (message.mangle !== false)
            writer.tag(54, WireType.Varint).bool(message.mangle);
        /* int32 improved_mangle = 55; */
        if (message.improvedMangle !== 0)
            writer.tag(55, WireType.Varint).int32(message.improvedMangle);
        /* int32 rend_and_tear = 56; */
        if (message.rendAndTear !== 0)
            writer.tag(56, WireType.Varint).int32(message.rendAndTear);
        /* bool primal_gore = 57; */
        if (message.primalGore !== false)
            writer.tag(57, WireType.Varint).bool(message.primalGore);
        /* bool berserk = 58; */
        if (message.berserk !== false)
            writer.tag(58, WireType.Varint).bool(message.berserk);
        /* int32 improved_mark_of_the_wild = 59; */
        if (message.improvedMarkOfTheWild !== 0)
            writer.tag(59, WireType.Varint).int32(message.improvedMarkOfTheWild);
        /* int32 natures_focus = 60; */
        if (message.naturesFocus !== 0)
            writer.tag(60, WireType.Varint).int32(message.naturesFocus);
        /* int32 furor = 61; */
        if (message.furor !== 0)
            writer.tag(61, WireType.Varint).int32(message.furor);
        /* int32 naturalist = 62; */
        if (message.naturalist !== 0)
            writer.tag(62, WireType.Varint).int32(message.naturalist);
        /* int32 subtlety = 63; */
        if (message.subtlety !== 0)
            writer.tag(63, WireType.Varint).int32(message.subtlety);
        /* int32 natural_shapeshifter = 64; */
        if (message.naturalShapeshifter !== 0)
            writer.tag(64, WireType.Varint).int32(message.naturalShapeshifter);
        /* int32 intensity = 65; */
        if (message.intensity !== 0)
            writer.tag(65, WireType.Varint).int32(message.intensity);
        /* bool omen_of_clarity = 66; */
        if (message.omenOfClarity !== false)
            writer.tag(66, WireType.Varint).bool(message.omenOfClarity);
        /* int32 master_shapeshifter = 67; */
        if (message.masterShapeshifter !== 0)
            writer.tag(67, WireType.Varint).int32(message.masterShapeshifter);
        /* int32 tranquil_spirit = 68; */
        if (message.tranquilSpirit !== 0)
            writer.tag(68, WireType.Varint).int32(message.tranquilSpirit);
        /* int32 improved_rejuvenation = 69; */
        if (message.improvedRejuvenation !== 0)
            writer.tag(69, WireType.Varint).int32(message.improvedRejuvenation);
        /* bool natures_swiftness = 70; */
        if (message.naturesSwiftness !== false)
            writer.tag(70, WireType.Varint).bool(message.naturesSwiftness);
        /* int32 gift_of_nature = 71; */
        if (message.giftOfNature !== 0)
            writer.tag(71, WireType.Varint).int32(message.giftOfNature);
        /* int32 improved_tranquility = 72; */
        if (message.improvedTranquility !== 0)
            writer.tag(72, WireType.Varint).int32(message.improvedTranquility);
        /* int32 empowered_touch = 73; */
        if (message.empoweredTouch !== 0)
            writer.tag(73, WireType.Varint).int32(message.empoweredTouch);
        /* int32 natures_bounty = 74; */
        if (message.naturesBounty !== 0)
            writer.tag(74, WireType.Varint).int32(message.naturesBounty);
        /* int32 living_spirit = 75; */
        if (message.livingSpirit !== 0)
            writer.tag(75, WireType.Varint).int32(message.livingSpirit);
        /* bool swiftmend = 76; */
        if (message.swiftmend !== false)
            writer.tag(76, WireType.Varint).bool(message.swiftmend);
        /* int32 natural_perfection = 77; */
        if (message.naturalPerfection !== 0)
            writer.tag(77, WireType.Varint).int32(message.naturalPerfection);
        /* int32 empowered_rejuvenation = 78; */
        if (message.empoweredRejuvenation !== 0)
            writer.tag(78, WireType.Varint).int32(message.empoweredRejuvenation);
        /* int32 living_seed = 79; */
        if (message.livingSeed !== 0)
            writer.tag(79, WireType.Varint).int32(message.livingSeed);
        /* int32 revitalize = 80; */
        if (message.revitalize !== 0)
            writer.tag(80, WireType.Varint).int32(message.revitalize);
        /* bool tree_of_life = 81; */
        if (message.treeOfLife !== false)
            writer.tag(81, WireType.Varint).bool(message.treeOfLife);
        /* int32 improved_tree_of_life = 82; */
        if (message.improvedTreeOfLife !== 0)
            writer.tag(82, WireType.Varint).int32(message.improvedTreeOfLife);
        /* int32 improved_barkskin = 83; */
        if (message.improvedBarkskin !== 0)
            writer.tag(83, WireType.Varint).int32(message.improvedBarkskin);
        /* int32 gift_of_the_earthmother = 84; */
        if (message.giftOfTheEarthmother !== 0)
            writer.tag(84, WireType.Varint).int32(message.giftOfTheEarthmother);
        /* bool wild_growth = 85; */
        if (message.wildGrowth !== false)
            writer.tag(85, WireType.Varint).bool(message.wildGrowth);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.DruidTalents
 */
export const DruidTalents = new DruidTalents$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BalanceDruid$Type extends MessageType<BalanceDruid> {
    constructor() {
        super("proto.BalanceDruid", [
            { no: 3, name: "options", kind: "message", T: () => BalanceDruid_Options }
        ]);
    }
    create(value?: PartialMessage<BalanceDruid>): BalanceDruid {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BalanceDruid>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BalanceDruid): BalanceDruid {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.BalanceDruid.Options options */ 3:
                    message.options = BalanceDruid_Options.internalBinaryRead(reader, reader.uint32(), options, message.options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BalanceDruid, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.BalanceDruid.Options options = 3; */
        if (message.options)
            BalanceDruid_Options.internalBinaryWrite(message.options, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BalanceDruid
 */
export const BalanceDruid = new BalanceDruid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BalanceDruid_Rotation$Type extends MessageType<BalanceDruid_Rotation> {
    constructor() {
        super("proto.BalanceDruid.Rotation", []);
    }
    create(value?: PartialMessage<BalanceDruid_Rotation>): BalanceDruid_Rotation {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BalanceDruid_Rotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BalanceDruid_Rotation): BalanceDruid_Rotation {
        return target ?? this.create();
    }
    internalBinaryWrite(message: BalanceDruid_Rotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BalanceDruid.Rotation
 */
export const BalanceDruid_Rotation = new BalanceDruid_Rotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BalanceDruid_Options$Type extends MessageType<BalanceDruid_Options> {
    constructor() {
        super("proto.BalanceDruid.Options", [
            { no: 1, name: "innervate_target", kind: "message", T: () => UnitReference },
            { no: 2, name: "okf_uptime", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<BalanceDruid_Options>): BalanceDruid_Options {
        const message = { okfUptime: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BalanceDruid_Options>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BalanceDruid_Options): BalanceDruid_Options {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference innervate_target */ 1:
                    message.innervateTarget = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.innervateTarget);
                    break;
                case /* float okf_uptime */ 2:
                    message.okfUptime = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BalanceDruid_Options, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference innervate_target = 1; */
        if (message.innervateTarget)
            UnitReference.internalBinaryWrite(message.innervateTarget, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* float okf_uptime = 2; */
        if (message.okfUptime !== 0)
            writer.tag(2, WireType.Bit32).float(message.okfUptime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BalanceDruid.Options
 */
export const BalanceDruid_Options = new BalanceDruid_Options$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeralDruid$Type extends MessageType<FeralDruid> {
    constructor() {
        super("proto.FeralDruid", [
            { no: 1, name: "rotation", kind: "message", T: () => FeralDruid_Rotation },
            { no: 3, name: "options", kind: "message", T: () => FeralDruid_Options }
        ]);
    }
    create(value?: PartialMessage<FeralDruid>): FeralDruid {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeralDruid>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeralDruid): FeralDruid {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.FeralDruid.Rotation rotation */ 1:
                    message.rotation = FeralDruid_Rotation.internalBinaryRead(reader, reader.uint32(), options, message.rotation);
                    break;
                case /* proto.FeralDruid.Options options */ 3:
                    message.options = FeralDruid_Options.internalBinaryRead(reader, reader.uint32(), options, message.options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeralDruid, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.FeralDruid.Rotation rotation = 1; */
        if (message.rotation)
            FeralDruid_Rotation.internalBinaryWrite(message.rotation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.FeralDruid.Options options = 3; */
        if (message.options)
            FeralDruid_Options.internalBinaryWrite(message.options, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.FeralDruid
 */
export const FeralDruid = new FeralDruid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeralDruid_Rotation$Type extends MessageType<FeralDruid_Rotation> {
    constructor() {
        super("proto.FeralDruid.Rotation", [
            { no: 1, name: "bear_weave_type", kind: "enum", T: () => ["proto.FeralDruid.Rotation.BearweaveType", FeralDruid_Rotation_BearweaveType] },
            { no: 2, name: "maintain_faerie_fire", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "min_combos_for_rip", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "use_rake", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "use_bite", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "mangle_spam", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "bite_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "min_combos_for_bite", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "berserk_bite_thresh", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "berserk_ff_thresh", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "rip_leeway", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "powerbear", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "min_roar_offset", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "bite_mode_type", kind: "enum", T: () => ["proto.FeralDruid.Rotation.BiteModeType", FeralDruid_Rotation_BiteModeType] },
            { no: 13, name: "hot_uptime", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 14, name: "snek_weave", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "flower_weave", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "raid_targets", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "manual_params", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "max_ff_delay", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 21, name: "rotation_type", kind: "enum", T: () => ["proto.FeralDruid.Rotation.AplType", FeralDruid_Rotation_AplType] },
            { no: 22, name: "pre_pop_berserk", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "pre_pop_ooc", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<FeralDruid_Rotation>): FeralDruid_Rotation {
        const message = { bearWeaveType: 0, maintainFaerieFire: false, minCombosForRip: 0, useRake: false, useBite: false, mangleSpam: false, biteTime: 0, minCombosForBite: 0, berserkBiteThresh: 0, berserkFfThresh: 0, ripLeeway: 0, powerbear: false, minRoarOffset: 0, biteModeType: 0, hotUptime: 0, snekWeave: false, flowerWeave: false, raidTargets: 0, manualParams: false, maxFfDelay: 0, rotationType: 0, prePopBerserk: false, prePopOoc: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeralDruid_Rotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeralDruid_Rotation): FeralDruid_Rotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.FeralDruid.Rotation.BearweaveType bear_weave_type */ 1:
                    message.bearWeaveType = reader.int32();
                    break;
                case /* bool maintain_faerie_fire */ 2:
                    message.maintainFaerieFire = reader.bool();
                    break;
                case /* int32 min_combos_for_rip */ 3:
                    message.minCombosForRip = reader.int32();
                    break;
                case /* bool use_rake */ 4:
                    message.useRake = reader.bool();
                    break;
                case /* bool use_bite */ 5:
                    message.useBite = reader.bool();
                    break;
                case /* bool mangle_spam */ 6:
                    message.mangleSpam = reader.bool();
                    break;
                case /* float bite_time */ 7:
                    message.biteTime = reader.float();
                    break;
                case /* int32 min_combos_for_bite */ 8:
                    message.minCombosForBite = reader.int32();
                    break;
                case /* int32 berserk_bite_thresh */ 9:
                    message.berserkBiteThresh = reader.int32();
                    break;
                case /* int32 berserk_ff_thresh */ 18:
                    message.berserkFfThresh = reader.int32();
                    break;
                case /* int32 rip_leeway */ 19:
                    message.ripLeeway = reader.int32();
                    break;
                case /* bool powerbear */ 10:
                    message.powerbear = reader.bool();
                    break;
                case /* float min_roar_offset */ 11:
                    message.minRoarOffset = reader.float();
                    break;
                case /* proto.FeralDruid.Rotation.BiteModeType bite_mode_type */ 12:
                    message.biteModeType = reader.int32();
                    break;
                case /* float hot_uptime */ 13:
                    message.hotUptime = reader.float();
                    break;
                case /* bool snek_weave */ 14:
                    message.snekWeave = reader.bool();
                    break;
                case /* bool flower_weave */ 15:
                    message.flowerWeave = reader.bool();
                    break;
                case /* int32 raid_targets */ 16:
                    message.raidTargets = reader.int32();
                    break;
                case /* bool manual_params */ 17:
                    message.manualParams = reader.bool();
                    break;
                case /* float max_ff_delay */ 20:
                    message.maxFfDelay = reader.float();
                    break;
                case /* proto.FeralDruid.Rotation.AplType rotation_type */ 21:
                    message.rotationType = reader.int32();
                    break;
                case /* bool pre_pop_berserk */ 22:
                    message.prePopBerserk = reader.bool();
                    break;
                case /* bool pre_pop_ooc */ 23:
                    message.prePopOoc = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeralDruid_Rotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.FeralDruid.Rotation.BearweaveType bear_weave_type = 1; */
        if (message.bearWeaveType !== 0)
            writer.tag(1, WireType.Varint).int32(message.bearWeaveType);
        /* bool maintain_faerie_fire = 2; */
        if (message.maintainFaerieFire !== false)
            writer.tag(2, WireType.Varint).bool(message.maintainFaerieFire);
        /* int32 min_combos_for_rip = 3; */
        if (message.minCombosForRip !== 0)
            writer.tag(3, WireType.Varint).int32(message.minCombosForRip);
        /* bool use_rake = 4; */
        if (message.useRake !== false)
            writer.tag(4, WireType.Varint).bool(message.useRake);
        /* bool use_bite = 5; */
        if (message.useBite !== false)
            writer.tag(5, WireType.Varint).bool(message.useBite);
        /* bool mangle_spam = 6; */
        if (message.mangleSpam !== false)
            writer.tag(6, WireType.Varint).bool(message.mangleSpam);
        /* float bite_time = 7; */
        if (message.biteTime !== 0)
            writer.tag(7, WireType.Bit32).float(message.biteTime);
        /* int32 min_combos_for_bite = 8; */
        if (message.minCombosForBite !== 0)
            writer.tag(8, WireType.Varint).int32(message.minCombosForBite);
        /* int32 berserk_bite_thresh = 9; */
        if (message.berserkBiteThresh !== 0)
            writer.tag(9, WireType.Varint).int32(message.berserkBiteThresh);
        /* int32 berserk_ff_thresh = 18; */
        if (message.berserkFfThresh !== 0)
            writer.tag(18, WireType.Varint).int32(message.berserkFfThresh);
        /* int32 rip_leeway = 19; */
        if (message.ripLeeway !== 0)
            writer.tag(19, WireType.Varint).int32(message.ripLeeway);
        /* bool powerbear = 10; */
        if (message.powerbear !== false)
            writer.tag(10, WireType.Varint).bool(message.powerbear);
        /* float min_roar_offset = 11; */
        if (message.minRoarOffset !== 0)
            writer.tag(11, WireType.Bit32).float(message.minRoarOffset);
        /* proto.FeralDruid.Rotation.BiteModeType bite_mode_type = 12; */
        if (message.biteModeType !== 0)
            writer.tag(12, WireType.Varint).int32(message.biteModeType);
        /* float hot_uptime = 13; */
        if (message.hotUptime !== 0)
            writer.tag(13, WireType.Bit32).float(message.hotUptime);
        /* bool snek_weave = 14; */
        if (message.snekWeave !== false)
            writer.tag(14, WireType.Varint).bool(message.snekWeave);
        /* bool flower_weave = 15; */
        if (message.flowerWeave !== false)
            writer.tag(15, WireType.Varint).bool(message.flowerWeave);
        /* int32 raid_targets = 16; */
        if (message.raidTargets !== 0)
            writer.tag(16, WireType.Varint).int32(message.raidTargets);
        /* bool manual_params = 17; */
        if (message.manualParams !== false)
            writer.tag(17, WireType.Varint).bool(message.manualParams);
        /* float max_ff_delay = 20; */
        if (message.maxFfDelay !== 0)
            writer.tag(20, WireType.Bit32).float(message.maxFfDelay);
        /* proto.FeralDruid.Rotation.AplType rotation_type = 21; */
        if (message.rotationType !== 0)
            writer.tag(21, WireType.Varint).int32(message.rotationType);
        /* bool pre_pop_berserk = 22; */
        if (message.prePopBerserk !== false)
            writer.tag(22, WireType.Varint).bool(message.prePopBerserk);
        /* bool pre_pop_ooc = 23; */
        if (message.prePopOoc !== false)
            writer.tag(23, WireType.Varint).bool(message.prePopOoc);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.FeralDruid.Rotation
 */
export const FeralDruid_Rotation = new FeralDruid_Rotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeralDruid_Options$Type extends MessageType<FeralDruid_Options> {
    constructor() {
        super("proto.FeralDruid.Options", [
            { no: 1, name: "innervate_target", kind: "message", T: () => UnitReference },
            { no: 2, name: "latency_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "assume_bleed_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<FeralDruid_Options>): FeralDruid_Options {
        const message = { latencyMs: 0, assumeBleedActive: false };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeralDruid_Options>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeralDruid_Options): FeralDruid_Options {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference innervate_target */ 1:
                    message.innervateTarget = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.innervateTarget);
                    break;
                case /* int32 latency_ms */ 2:
                    message.latencyMs = reader.int32();
                    break;
                case /* bool assume_bleed_active */ 4:
                    message.assumeBleedActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeralDruid_Options, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference innervate_target = 1; */
        if (message.innervateTarget)
            UnitReference.internalBinaryWrite(message.innervateTarget, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 latency_ms = 2; */
        if (message.latencyMs !== 0)
            writer.tag(2, WireType.Varint).int32(message.latencyMs);
        /* bool assume_bleed_active = 4; */
        if (message.assumeBleedActive !== false)
            writer.tag(4, WireType.Varint).bool(message.assumeBleedActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.FeralDruid.Options
 */
export const FeralDruid_Options = new FeralDruid_Options$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeralTankDruid$Type extends MessageType<FeralTankDruid> {
    constructor() {
        super("proto.FeralTankDruid", [
            { no: 3, name: "options", kind: "message", T: () => FeralTankDruid_Options }
        ]);
    }
    create(value?: PartialMessage<FeralTankDruid>): FeralTankDruid {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeralTankDruid>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeralTankDruid): FeralTankDruid {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.FeralTankDruid.Options options */ 3:
                    message.options = FeralTankDruid_Options.internalBinaryRead(reader, reader.uint32(), options, message.options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeralTankDruid, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.FeralTankDruid.Options options = 3; */
        if (message.options)
            FeralTankDruid_Options.internalBinaryWrite(message.options, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.FeralTankDruid
 */
export const FeralTankDruid = new FeralTankDruid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeralTankDruid_Rotation$Type extends MessageType<FeralTankDruid_Rotation> {
    constructor() {
        super("proto.FeralTankDruid.Rotation", [
            { no: 1, name: "maul_rage_threshold", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "maintain_demoralizing_roar", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "lacerate_time", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<FeralTankDruid_Rotation>): FeralTankDruid_Rotation {
        const message = { maulRageThreshold: 0, maintainDemoralizingRoar: false, lacerateTime: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeralTankDruid_Rotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeralTankDruid_Rotation): FeralTankDruid_Rotation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 maul_rage_threshold */ 1:
                    message.maulRageThreshold = reader.int32();
                    break;
                case /* bool maintain_demoralizing_roar */ 2:
                    message.maintainDemoralizingRoar = reader.bool();
                    break;
                case /* double lacerate_time */ 3:
                    message.lacerateTime = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeralTankDruid_Rotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 maul_rage_threshold = 1; */
        if (message.maulRageThreshold !== 0)
            writer.tag(1, WireType.Varint).int32(message.maulRageThreshold);
        /* bool maintain_demoralizing_roar = 2; */
        if (message.maintainDemoralizingRoar !== false)
            writer.tag(2, WireType.Varint).bool(message.maintainDemoralizingRoar);
        /* double lacerate_time = 3; */
        if (message.lacerateTime !== 0)
            writer.tag(3, WireType.Bit64).double(message.lacerateTime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.FeralTankDruid.Rotation
 */
export const FeralTankDruid_Rotation = new FeralTankDruid_Rotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeralTankDruid_Options$Type extends MessageType<FeralTankDruid_Options> {
    constructor() {
        super("proto.FeralTankDruid.Options", [
            { no: 1, name: "innervate_target", kind: "message", T: () => UnitReference },
            { no: 2, name: "starting_rage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<FeralTankDruid_Options>): FeralTankDruid_Options {
        const message = { startingRage: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<FeralTankDruid_Options>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FeralTankDruid_Options): FeralTankDruid_Options {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference innervate_target */ 1:
                    message.innervateTarget = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.innervateTarget);
                    break;
                case /* double starting_rage */ 2:
                    message.startingRage = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FeralTankDruid_Options, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference innervate_target = 1; */
        if (message.innervateTarget)
            UnitReference.internalBinaryWrite(message.innervateTarget, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* double starting_rage = 2; */
        if (message.startingRage !== 0)
            writer.tag(2, WireType.Bit64).double(message.startingRage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.FeralTankDruid.Options
 */
export const FeralTankDruid_Options = new FeralTankDruid_Options$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestorationDruid$Type extends MessageType<RestorationDruid> {
    constructor() {
        super("proto.RestorationDruid", [
            { no: 3, name: "options", kind: "message", T: () => RestorationDruid_Options }
        ]);
    }
    create(value?: PartialMessage<RestorationDruid>): RestorationDruid {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RestorationDruid>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RestorationDruid): RestorationDruid {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.RestorationDruid.Options options */ 3:
                    message.options = RestorationDruid_Options.internalBinaryRead(reader, reader.uint32(), options, message.options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RestorationDruid, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.RestorationDruid.Options options = 3; */
        if (message.options)
            RestorationDruid_Options.internalBinaryWrite(message.options, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RestorationDruid
 */
export const RestorationDruid = new RestorationDruid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestorationDruid_Rotation$Type extends MessageType<RestorationDruid_Rotation> {
    constructor() {
        super("proto.RestorationDruid.Rotation", []);
    }
    create(value?: PartialMessage<RestorationDruid_Rotation>): RestorationDruid_Rotation {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RestorationDruid_Rotation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RestorationDruid_Rotation): RestorationDruid_Rotation {
        return target ?? this.create();
    }
    internalBinaryWrite(message: RestorationDruid_Rotation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RestorationDruid.Rotation
 */
export const RestorationDruid_Rotation = new RestorationDruid_Rotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestorationDruid_Options$Type extends MessageType<RestorationDruid_Options> {
    constructor() {
        super("proto.RestorationDruid.Options", [
            { no: 1, name: "innervate_target", kind: "message", T: () => UnitReference }
        ]);
    }
    create(value?: PartialMessage<RestorationDruid_Options>): RestorationDruid_Options {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RestorationDruid_Options>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RestorationDruid_Options): RestorationDruid_Options {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.UnitReference innervate_target */ 1:
                    message.innervateTarget = UnitReference.internalBinaryRead(reader, reader.uint32(), options, message.innervateTarget);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RestorationDruid_Options, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.UnitReference innervate_target = 1; */
        if (message.innervateTarget)
            UnitReference.internalBinaryWrite(message.innervateTarget, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RestorationDruid.Options
 */
export const RestorationDruid_Options = new RestorationDruid_Options$Type();
